import { Controller } from "stimulus";
import 'tom-select';

export default class FormController extends Controller {

    connect() {
        if (window.supercast) {
            window.supercast.trigger('pageload')
        }

    }

    titleTargetConnected(el) {
        el.addEventListener('input', this.maybeEnableSubmit.bind(this));
        this.maybeEnableSubmit();
    }

    titleTargetDisconnected(el) {
        el.removeEventListener('input', this.maybeEnableSubmit.bind(this));
    }

    maybeEnableSubmit() {
        if (this.titleTarget.value.length > 0) {
            this.submitTarget.disabled = false;
        } else {
            this.submitTarget.disabled = true;
        }
    }

    exit() {
        // If the title is empty, just go back to the list
        // as this is essentially aborting the form.
        if (this.titleTarget.value.length === 0) {
            window.Turbo.visit(`/dashboard/shared/posts`);
        } else {
            window.Turbo.visit(`/dashboard/shared/posts/${this.postIdValue || ''}`);
        }
    }
}

FormController.values = { postId: Number }
FormController.targets = ["title", "submit"]
